/* eslint-disable no-param-reassign */
/* global G */

/**
 * Clears all enumerable properties from `object`.
 * @param {Object} object
 */
const clear = object => Object.keys(object).reduce((acc, key) => {
  delete acc[key]
  return acc
}, object)

/**
 * Clears the state of `component` and calls itself for each one of its children.
 * @param {Gaia.Component.Spec} component
 * @returns {Gaia.Component.Spec}
 */
const reset = (component) => {
  clear(component[G.STATE])
  component[G.CHILDREN]?.forEach(reset)
  return component
}

export default reset
